import { createPortal } from "react-dom";

import { Column, Text } from "@/components";

import { performanceTierTextClass } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { PerformanceTier } from "@/types";

const TOOLTIP_GAP_PX = 10;

// The hovered week's value, portalled out so the short card can't clip it.
export const TrendWeekTooltip = ({
  label,
  tier,
  value,
  x,
  y,
}: {
  label: string;
  tier: PerformanceTier | null;
  value: string;
  x: number;
  y: number;
}) =>
  createPortal(
    <Column
      className="pointer-events-none fixed z-50 whitespace-nowrap rounded-md border border-slate-200 bg-white px-3 py-2 shadow-md"
      style={{
        left: x,
        top: y - TOOLTIP_GAP_PX,
        transform: "translate(-50%, -100%)",
      }}
    >
      <Text className="text-xs font-normal text-slate-500">
        Week of {label}
      </Text>
      <Text
        className={cn(
          "text-lg font-semibold tabular-nums leading-tight",
          tier ? performanceTierTextClass[tier] : "text-slate-400",
        )}
      >
        {value}
      </Text>
    </Column>,
    document.body,
  );
